module.exports = __webpack_public_path__ + "static/bertens-red-98020d910e203a2a7f67138a90aa60d3.png";